module.exports = __webpack_public_path__ + "img/lung_overlay_anterior.07964053.png";